var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.5V18.5C3.5 19.3284 4.17157 20 5 20H20C20.8284 20 21.5 19.3284 21.5 18.5V13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 3C13.25 2.58579 12.9142 2.25 12.5 2.25C12.0858 2.25 11.75 2.58579 11.75 3L13.25 3ZM11.9697 17.5303C12.2626 17.8232 12.7374 17.8232 13.0303 17.5303L17.8033 12.7574C18.0962 12.4645 18.0962 11.9896 17.8033 11.6967C17.5104 11.4038 17.0355 11.4038 16.7426 11.6967L12.5 15.9393L8.25736 11.6967C7.96447 11.4038 7.48959 11.4038 7.1967 11.6967C6.90381 11.9896 6.90381 12.4645 7.1967 12.7574L11.9697 17.5303ZM11.75 3L11.75 17L13.25 17L13.25 3L11.75 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNew);
export default __webpack_public_path__ + "static/media/download-new.b8fcc9ad760b344bc979ffc9d8bb0be7.svg";
export { ForwardRef as ReactComponent };